// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"co-z","imageAndVideoCount":"do-z","imageAndVideoContainer":"eo-z","viewAllReviews":"fo-z"};